module.exports = __webpack_public_path__ + "img/bioRxiv_logo.ead3316a.png";